import React, { useEffect, useState } from 'react'
// import logo1 from '../assets/img/SE-logo.webp'
// import maralogo from '../assets/img/mara.png'
// import qeacLogo from '../assets/img/qeac.png'

function Footer() {
    const today=new Date();
    return (
        <>
            {/* <footer className="footer-section">
                <div className="container">
                   
                    <div className="subcribe-content">
                        <h6>SEARCH EDUCATION-  WHERE TECHNOLOGY, EXCELLENCE & UNDERSTANDING COME TOGETHER</h6>
                        <p>Facilitating students acquire perfect-fit education placements that ultimately changes their lives! Established in 2015, Search Education strives to bring your overseas education dreams to life. We offer an exceptionally customized service that surpasses the expectation of clients. International reach and established global offices work round the clock to engage with a diverse range of educationists to cater to the specific needs of clients.</p>
                    </div>

                    <div className="verified-partner text-center">
                        <img src={'/assets/img/img2.png'} alt="mara" width="10%" />
                        <img src={'/assets/img/img1.png'} alt="qeac" width="16%" />
                    </div>
                </div>
            </footer> */}

            <section>
                <div className="footer-broder-top">
                    <div className="container">
                        <p>&copy; <span>{today.getFullYear()}</span> <a href="https://searcheducation.in/">searcheducation.in</a> ALL RIGHTS RESERVED.</p>
                    </div>
                </div>
            </section>

            {/* <section>
                <div className="call-icon" data-toggle="modal" data-target="#iframeModal">
                    <a href="book-appointment.html"> <i className="fa fa-calendar-check-o" aria-hidden="true"></i> <span>Book Now</span></a>
                </div>
            </section> */}
        </>
    )
}

export default Footer